var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"appWrapper"},[(_vm.isMobileCheck == 'true' || _vm.isTabletCheck == 'true')?_c('div',[_c('mobileHeader')],1):_c('div',[_c('appHeader')],1),_vm._v(" "),_c('div',{staticClass:"appContainerHero"},[_c('div',{staticClass:"router-bx-1"},[_c('vue-progress-bar'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"push"})]),_vm._v(" "),(_vm.isMobileCheck == 'true' || _vm.isTabletCheck == 'true')?_c('div',[(_vm.showHeaderFooter)?_c('mobileFooter'):_vm._e()],1):_c('div',[(
          [
            'logIn',
            'dsMarket',
            'RegisterHome',
            'appHome',
            'personalAccount',
            'businessAccount' ].includes(_vm.$route.name)
        )?_c('div',[_c('div',{staticClass:"appFooterHero"},[_c('appFooter')],1),_vm._v(" "),_c('copyWrite')],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169e6e16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 